import { api } from '@/api'
import qs from 'qs'

export interface getPriorityParams {
  scope?: string
  include?: string
  q?: any
  page?: number
  perPage?: number
}

export default {
  get: ({ scope, include, q, page, perPage }: getPriorityParams) => {
    return api.$get('/priorities', {
      params: {
        scope,
        include,
        q,
        page,
        per_page: perPage
      },
      paramsSerializer: (params:getPriorityParams) => {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      }
    })
  }
}
